/**
 * 시청자 뷰 vs 스트리머 프리뷰 — docs/DESIGN.md §2.1.
 *
 * URL 쿼리 `?mode=preview`이면 스트리머 프리뷰 모드로 렌더합니다.
 * 일반 OBS 브라우저 소스는 시청자 뷰.
 *
 * 스트리머 프리뷰 모드에서는:
 * - 상태 2 (connecting) 의 디버그 dot 노출
 * - 상태 9 (filter-triggered) 의 차단 뱃지 노출
 * - 상태 12 (paused) 의 반투명 오버레이 노출
 * - TTS skip / 삭제 버튼 노출
 */
export type ViewerMode = 'public' | 'preview';

export function detectViewerMode(url: string = typeof window !== 'undefined' ? window.location.search : ''): ViewerMode {
  // URLSearchParams는 "?" prefix를 허용.
  const params = new URLSearchParams(url.startsWith('?') ? url : `?${url}`);
  return params.get('mode') === 'preview' ? 'preview' : 'public';
}
